var render = function render(){var _vm=this,_c=_vm._self._c;return _c('radial-progress-bar',{staticClass:"baseShadow",attrs:{"id":"radial-progress","diameter":_vm.diameter,"completed-steps":_vm.points,"total-steps":_vm.stepsForLevel,"innerStrokeColor":"navy","startColor":"#ff3a00","stopColor":"darkorange"}},[_c('h1',[_vm._v(_vm._s(_vm.levelName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }